import React from "react";
import VisualSearch from "../components/VisualSearch";
import { FlaskConical, ArrowDown } from "lucide-react";

const Step = ({ label }) => (
  <div className="flex items-center gap-3">
    <div className="font-mono text-xs px-3 py-1 border rounded-sm bg-card">{label}</div>
  </div>
);

const TestPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12 space-y-10">
      <div>
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-brand font-semibold mb-4">
          <FlaskConical className="w-4 h-4" /> Diagnostics
        </div>
        <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">Image Search Test</h1>
        <p className="text-muted-foreground mt-3 max-w-2xl">
          Upload a known Mahindra part image and verify the correct Part Number appears near the top. Full debug
          information (embedding, vector search, images searched, execution time) is shown below the options.
        </p>
        <div className="flex flex-wrap items-center gap-3 mt-6">
          <Step label="Upload image" />
          <ArrowDown className="w-3 h-3 text-muted-foreground rotate-[-90deg]" />
          <Step label="Generate embedding" />
          <ArrowDown className="w-3 h-3 text-muted-foreground rotate-[-90deg]" />
          <Step label="Vector search" />
          <ArrowDown className="w-3 h-3 text-muted-foreground rotate-[-90deg]" />
          <Step label="Top results + scores" />
        </div>
      </div>

      <VisualSearch showDebug allowModeSelect showScores allowModel={false} />
    </div>
  );
};

export default TestPage;
